import Events from '@clearkit/icons/glyphs/Event';
import Pageview from '@clearkit/icons/glyphs/View';
import { CKTab, CKTabList, CKTabs } from '@clearkit/react';

import SearchTextField from '~/components/SearchTextField';
import Select from '~/components/Select';
import { useEventTypes } from '~/components/Sidebar/hooks/useEventTypes.ts';
import { PersonEventsList } from '~/components/Sidebar/PersonEventsList/EventsList.tsx';
import { PersonPageviewsList } from '~/components/Sidebar/PersonEventsList/PageviewsList.tsx';

const PersonActivity = ({ person, className }) => {
  const [type, setType] = useState();
  const [path, setPath] = useState('');
  const [tabIndex, setTabIndex] = useState(0);
  const { eventTypes } = useEventTypes();

  return (
    <div className={className}>
      <CKTabs isSegmented index={tabIndex} onChange={setTabIndex}>
        <div className="flex flex-row justify-between px-8 py-6 border-b border-gray-200 align-center bg-gray-0">
          <CKTabList aria-label="My tabs">
            <CKTab label="Pageviews" id="page" icon={<Pageview />}>
              Pageviews
            </CKTab>
            <CKTab label="Events" id="events" icon={<Events />}>
              Events
            </CKTab>
          </CKTabList>

          {tabIndex === 0 && (
            <SearchTextField
              placeholder="Search by path..."
              className="flex-grow w-6/12 max-w-md"
              onSearch={(e) => {
                let value = e.target.value;
                if (value && !value.startsWith('/')) {
                  value = `/${value}`;
                }
                setPath(value);
              }}
              value={path}
            />
          )}

          {tabIndex === 1 && (
            <Select
              className="flex-grow w-6/12 max-w-md"
              options={['', ...eventTypes]}
              getOptionValue={(option) => option || 'All'}
              getOptionLabel={(option) => option || 'All events'}
              placeholder="Filter by event type"
              onChange={(value) => setType(value)}
              isDisabled={!eventTypes?.length}
              value={[type || 'All events']}
            />
          )}
        </div>
      </CKTabs>

      <div className="flex flex-col flex-grow">
        {tabIndex === 0 && (
          <PersonPageviewsList person={person} path={path} className="px-8" />
        )}
        {tabIndex === 1 && (
          <PersonEventsList
            person={person}
            type={type}
            className="flex flex-col flex-grow px-4"
          />
        )}
      </div>
    </div>
  );
};

PersonActivity.propTypes = {
  person: PropTypes.object.isRequired,
  className: PropTypes.string,
};

export default PersonActivity;
